const MuiListItemOverrides = {
  MuiListItem: {
    styleOverrides: {
      root: ({
        theme,
        ownerState
      }) => ({
        gap: theme.spacing(2),
        minHeight: theme.spacing(6),
        ...(!ownerState.disablePadding && {
          paddingTop: theme.spacing(0.5),
          paddingBottom: theme.spacing(0.5),
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2)
        }),
        '&.MuiListItem-divider:last-child': {
          borderBottomColor: 'transparent'
        }
      })
    }
  },
  MuiListItemButton: {
    styleOverrides: {
      root: ({
        theme,
        ownerState
      }) => ({
        '&.MuiListItemButton-divider:last-child': {
          borderBottomColor: 'transparent'
        },
        padding: theme.spacing(0.5, 2),
        ...(ownerState.variant === 'sidebar' ? {
          '&.Mui-selected, &.Mui-selected:hover, :hover': {
            background: theme.palette.blue70
          }
        } : {
          gap: theme.spacing(2),
          background: theme.palette.background.paper,
          minHeight: theme.spacing(6)
        })
      })
    }
  },
  MuiListItemText: {
    styleOverrides: {
      root: ({
        theme
      }) => ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: theme.spacing(0.25, 0),
        '&.MuiListItemText-multiline': {
          paddingBottom: theme.spacing(0.5)
        }
      }),
      primary: ({
        theme
      }) => ({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&.MuiTypography-body1': {
          ...theme.typography.body02
        }
      }),
      secondary: ({
        theme
      }) => ({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&.MuiTypography-body2': {
          ...theme.typography.caption
        }
      })
    }
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: ({
        theme
      }) => ({
        minWidth: 0,
        color: theme.palette.text.primary
      })
    }
  },
  MuiListItemAvatar: {
    styleOverrides: {
      root: {
        minWidth: 0
      }
    }
  },
  MuiListItemSecondaryAction: {
    styleOverrides: {
      root: () => ({
        flex: '0 0 auto',
        position: 'relative',
        overflow: 'hidden',
        top: 'unset',
        right: 'unset',
        transform: 'unset',
        maxWidth: '50%',
        textOverflow: 'ellipsis'
      })
    }
  }
};

export { MuiListItemOverrides };
